import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Filters = createSvgIcon(
  <path d="M3.75.75h6.75V3H24v2.25H10.5V7.5H3.75V5.25H0V3h3.75V.75ZM6 3v2.25h2.25V3H6Zm15 10.125v2.25h-6.75v-2.25H0v-2.25h14.25v-2.25H21v2.25h3v2.25h-3Zm-4.5 0h2.25v-2.25H16.5v2.25ZM3.75 18.75H0V21h3.75v2.25h6.75V21H24v-2.25H10.5V16.5H3.75v2.25ZM6 21v-2.25h2.25V21H6Z" />,
  'Filters'
);

export { Filters };